import Vue from 'vue';
import Vuex from 'vuex';
import { mapState, mapGetters } from 'vuex';

const fastTrackFilter = Vue.component('fast-track-filter', {
    template: `
    <button v-if="getFastTrack.Text" class="icon-filter" v-bind:class="{ active: isActive }" data-filter="FastTrack" @click="addFilter" :aria-pressed="isPressed">
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
              <path d="M23.54 19.378a1.12 1.12 0 01-.032-1.12c.192-.355.561-.577.966-.579h3.122a1.612 1.612 0 011.364.762l2.942 4.686a1.645 1.645 0 010 1.745l-2.94 4.683a1.613 1.613 0 01-1.366.765h-3.121a1.103 1.103 0 01-.967-.58 1.119 1.119 0 01.035-1.124l2.894-4.62c-.001.001-2.897-4.618-2.897-4.618zm1.068-.518l3.024 4.823c.12.192.12.435 0 .627l-3.026 4.83h2.987a.433.433 0 00.367-.21l2.941-4.685a.461.461 0 000-.49l-2.943-4.688a.43.43 0 00-.364-.207h-2.986zm-5.697 5.137l-2.894-4.614a1.117 1.117 0 01-.035-1.123c.193-.356.563-.579.968-.58h3.121c.556.001 1.071.29 1.365.762l2.942 4.686a1.645 1.645 0 010 1.745l-2.94 4.683c-.295.474-.81.763-1.367.765h-3.12a1.103 1.103 0 01-.967-.58 1.119 1.119 0 01.035-1.124c-.002 0 2.892-4.62 2.892-4.62zm1.196-.314c.12.192.12.435 0 .627l-3.026 4.83h2.987a.432.432 0 00.367-.21l2.941-4.685a.461.461 0 000-.49l-2.943-4.688a.433.433 0 00-.365-.207H17.08c.002 0 3.027 4.823 3.027 4.823z"/>
              <circle fill="none" stroke="currentColor" stroke-miterlimit="10" cx="24" cy="24" r="23.5" class="hands-off" />
            </svg>
        </span>
        <div class="icon-text">
            {{ getFastTrack.Text }}
        </div>
    </button>`,
    data: function () {
        return {
            isActive: false
        }
    },
    methods: {
        addFilter(e) {
            this.$store.commit('filters/toggleActiveFilters', this.$el.dataset.filter);
            this.toggleActive();
            this.$store.dispatch('filterAttractions');
        },
        toggleActive() {
            if (this.$store.state.filters.activeFilters.includes(this.$el.dataset.filter)) {
                this.isActive = true;
            } else {
                this.isActive = false;
            }
        }
    },
    computed: {
        ...mapGetters('filters', ['getFastTrack']),
        isPressed() {
            return this.isActive.toString();
        }
    },
    mounted(){
        this.toggleActive();
    }

});

export { fastTrackFilter }